import { Fragment, useState } from "react";
import { useTable, usePagination } from "react-table";

const DataTable = ({
  data,
  columns,
  totalCount,
  setCurrentPage,
  currentPage,
}) => {
  const totalPages = Math.ceil(totalCount / 10);
  const [visibleRange, setVisibleRange] = useState([0, 4]); // Initially show 1 to 5

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } =
    useTable(
      {
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: 10 },
        pageSizeOptions: [10, 20, 50], // Specify available page sizes
      },
      usePagination // Add the usePagination hook
    );

  const handlePageClick = (pageIndex) => {
    setCurrentPage(pageIndex);

    if (pageIndex <= 2) {
      // If the page is near the beginning, show the first 5 pages
      setVisibleRange([0, 4]);
    } else if (pageIndex >= totalPages - 3) {
      // If the page is near the end, show the last 5 pages
      setVisibleRange([totalPages - 5, totalPages - 1]);
    } else {
      // Else, show the current page in the middle with two pages before and after
      setVisibleRange([pageIndex - 2, pageIndex + 2]);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];

    // First two pages
    pageNumbers.push(
      <li
        key={0}
        className={`page-item ${currentPage === 0 ? "active" : ""}`}
      >
        <span
          className="page-link"
          style={{ cursor: "pointer" }}
          onClick={() => handlePageClick(0)}
        >
          1
        </span>
      </li>
    );

    // Show the ellipsis only when not in the first few pages
    if (visibleRange[0] > 1) {
      pageNumbers.push(
        <li key="start-ellipsis" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Visible range of page numbers
    for (let i = visibleRange[0]; i <= visibleRange[1]; i++) {
      if (i > 0 && i < totalPages - 1) {
        pageNumbers.push(
          <li
            key={i}
            className={`page-item ${currentPage === i ? "active" : ""}`}
          >
            <span
              className="page-link"
              style={{ cursor: "pointer" }}
              onClick={() => handlePageClick(i)}
            >
              {i + 1}
            </span>
          </li>
        );
      }
    }

    // Show the ellipsis only when not in the last few pages
    if (visibleRange[1] < totalPages - 2) {
      pageNumbers.push(
        <li key="end-ellipsis" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Last page
    pageNumbers.push(
      <li
        key={totalPages - 1}
        className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`}
      >
        <span
          className="page-link"
          style={{ cursor: "pointer" }}
          onClick={() => handlePageClick(totalPages - 1)}
        >
          {totalPages}
        </span>
      </li>
    );

    return pageNumbers;
  };

  return (
    <Fragment>
      <div className="table-wrapper m-3">
        <table
          className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg"
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length === 0 ? (
              <tr>
                <td
                  colSpan={headerGroups[0].headers.length}
                  style={{ textAlign: "center", fontWeight: "bold" }}
                >
                  No data available
                </td>
              </tr>
            ) : (
              page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
        <ul
          className="pagination"
          style={{ float: "left", paddingTop: "10px" }}
        >
          {data.length !== 0 && renderPageNumbers()}
        </ul>
      </div>
      <div>
        {totalCount > 0 && (
          <p>{`Showing ${currentPage * 10 + 1} to ${
            currentPage * 10 + data.length
          } of ${totalCount} entries`}</p>
        )}
      </div>
    </Fragment>
  );
};

export default DataTable;
